export const GetAllGarmentType_REQUEST = "GetAllGarmentType_REQUEST";
export const GetAllGarmentType_SUCCESS = "GetAllGarmentType_SUCCESS";
export const GetAllGarmentType_FAIL = "GetAllGarmentType_FAIL";

export const AddGarmentType_REQUEST = "AddGarmentType_REQUEST";
export const AddGarmentType_SUCCESS = "AddGarmentType_SUCCESS";
export const AddGarmentType_FAIL = "AddGarmentType_FAIL";

export const UpdateGarmentType_REQUEST = "UpdateGarmentType_REQUEST";
export const UpdateGarmentType_SUCCESS = "UpdateGarmentType_SUCCESS";
export const UpdateGarmentType_FAIL = "UpdateGarmentType_FAIL";


export const GetAllInactiveGarmentType_REQUEST = "GetAllInactiveGarmentType_REQUEST";
export const GetAllInactiveGarmentType_SUCCESS = "GetAllInactiveGarmentType_SUCCESS";
export const GetAllInactiveGarmentType_FAIL = "GetAllInactiveGarmentType_FAIL";
